import './App.css';
import Iframe from './components/iframe'
import Door from './components/door'
import List from './components/list'
import Tip from './components/tip'
import Bio from './components/bio'
import { CountProvider } from "./utils/global";

function App() {
  return (
    <CountProvider>
      <div >
        <Tip id='tiptrace' />
        <Tip id='tipsort' />
        <Tip id='tipenigma' />
        {/* <Tip id='tipclone' />
        <Tip id='tiptravel' /> */}
        <Tip id='tipmtg' />
        <Door id='ldoor' >
          <List />
        </Door>
        <Door id='rdoor' >
          <Bio />
        </Door>
        <Iframe id='trace'
          ghLink='https://github.com/Jasper8628/contact_tracer'
          address='https://contact-tracer-29f4f.web.app/' />
        <Iframe id='sort'
          ghLink='https://github.com/Jasper8628/sorting_visualiser'
          address='https://sorting-visualiser-335f0.web.app/' />
        <Iframe id='enigma'
          ghLink='https://github.com/Jasper8628/enigma_machine'
          address='https://enigma-7f7c6.firebaseapp.com/' />
        {/* <Iframe id='clone'
          ghLink='https://github.com/Jasper8628/youtube_clone'
          address='https://enigma-7f7c6.firebaseapp.com/' />
        <Iframe id='travel'
          ghLink='https://github.com/Jasper8628/youtube_clone'
          address='https://theyearofgreta.com/' /> */}
        <Iframe id='mtg'
          ghLink='https://github.com/Jasper8628/GroupProjectOne'
          address='https://jasper8628.github.io/GroupProjectOne/' />
      </div>
    </CountProvider>
  );
}

export default App;
